import React, { useEffect, useRef, useState, useCallback } from 'react';
import axios from 'axios';
import moment from 'moment';
import styled from 'styled-components';
import { toast } from 'react-toastify';
import { loader } from 'helpers/generic';
import Tank from 'components/Tank';
import DeviationModal from './DeviationModal';
import { hasCapability } from 'helpers/user';
import CarrierSendLogsModal from './CarrierSendLogsModal';
import OcrPopup from './OcrPopup';
import ConfirmModal from './ConfirmModal';
import DeliveryNotesBCLogsModal from './DeliveryNotesBCLogsModal';
import DeliveryNotesAddModal from './DeliveryNotesAddModal';

const Tr = styled.tr`
	position: relative;

	& > td {
		text-align: unset !important;
		padding: 20px 10px;

		&:first-of-type {
			padding-left: ${props => props.isDeviation ? 40 : 0}px;
		}
	}

	.probes_wrapper {
		#loader {
			height: 20px;
			margin-left: 5px;
		}
	}

	.row-table-details {
		display: grid !important;
		grid-template-columns: 0.5rem 1fr 1fr;
		gap: 0.25rem !important;
		align-items: stretch;
		width: 100%;
	}

    .row-table-issues {
		display: grid !important;
		grid-template-columns: 0.5rem 1fr;
		gap: 0.25rem !important;
		align-items: stretch;
		width: 100%;
	}

	.col-table-details {
		height: 100%;
		display: flex;
		flex-direction: column;
	}

	.photo-btn:hover{
		color: var(--plenoil-orange) !important;
	}
`

const TableDetails = styled.table`
	width: 100%;

	td {
		font-size: 12px !important;

		padding-top: 5px;
		padding-bottom: 5px;
		border-bottom: 1px solid var(--bs-gray-300);

		&:nth-child(2) {
			padding-left: 5px;
			font-weight: 600;
		}

		&:nth-child(3) {
			width: 100px;
			text-align: right;
		}
	}
`;

const IncidencesWrapper = styled.div`
	.detail-col-right {
		display: flex;
	}
`;

const TableIncidenceType = styled.table`
	td {
		font-size: 10px !important;

		&:nth-child(1) {
			width: 20px;
		}
	}
`;

const IncidenceQuantities = styled.div`
	display: grid;
	grid-template-columns: 100px 1fr;
	gap: 0.5rem;
	width: 100%;
	align-items: center;

	.incidence-label {
		font-size: 10px;
		text-align: left;
		width: 100px;
		white-space: nowrap;
	}
	.incidence-input {
		input {
			padding: 0 5px;
			font-size: 12px;
			text-align: right;
		}
	}
	/* Custom radio color for incidence approval radios */
	input[type="radio"].incidence-radio-approval {
		accent-color: #002f73;
	}
`;

const ButtonClose = styled.button`
	div {
		font-size: 12px;
	}
`;


const ButtonsBottom = styled.div`
	justify-content: flex-end;

	button {
		width: auto;
		background: transparent;
		border: 0;
		display: inline-flex;
		justify-content: center;
		align-items: center;
		color: var(--bs-red);

		i {
			width: 18px;
			height: 18px;
			display: inline-flex;
			justify-content: center;
			align-items: center;
			margin: 0 auto;
		}
	}

	button:hover {
		text-decoration: underline;
	}
`;

let axiosCancelToken = null;

export default function TankerTrucks(props) {
	const [data, setData] = useState({});

	const [forceReload, setForceReload] = useState(false);
	const [deviationModal, setDeviationModal] = useState(false);
	const [carrierSendLogsModal, setCarrierSendLogsModal] = useState(false);
	const [confirmModal, setConfirmModal] = useState(null);
	const [probeData, setProbeData] = useState(null);
	const [bcLogsModal, setBcLogsModal] = useState(null);
	const [addDeliveryNoteModal, setAddDeliveryNoteModal] = useState(false);
	const [openAccordions, setOpenAccordions] = useState({});
	const [loadingDeliveryNotesGet, setLoadingDeliveryNotesGet] = useState(false);
	const [loadingDeliveryNotesBC, setLoadingDeliveryNotesBC] = useState(false);
	const [loadingDownload, setLoadingDownload] = useState({});
	// --- INICIO: Simulación de datos dinámicos solo en desarrollo ---
	// const [probeData, setProbeData] = useState(
	// 	process.env.NODE_ENV === 'development'
	// 		? {
	// 				diesel_percent: 75,
	// 				diesel_available: 15000,
	// 				splomo_percent: 40,
	// 				splomo_available: 8000,
	// 				error: 'Simulación de error de sonda (solo local)',
	// 			}
	// 		: null
	// );
	// --- FIN: Simulación de datos dinámicos solo en desarrollo ---
	const [probeLoading, setProbeLoading] = useState(false);
	const [editingObservations, setEditingObservations] = useState(false);
    const [ocrDetails, _setOcrDetails] = useState(false);
	const ocrDetailsRef = useRef(null);
	const setOcrDetails = (data) => {
		_setOcrDetails(data);
		ocrDetailsRef.current = data;
	}

	useEffect(() => {
		axiosCancelToken = axios.CancelToken.source();

		return function cleanup() {
           	axiosCancelToken.cancel();
        }
	}, []);

	const getData = useCallback(() => {
		axios.get('/api/tankertrucks/get/' + props.id, {
			params: {},
			cancelToken: axiosCancelToken.token
		}).then((response) => {
			let newData = {...response.data};
			setData((prev) => {
				if ( prev.incidence?.sp95_liters !== undefined ) newData.incidence.sp95_liters = prev.incidence.sp95_liters; // Prevent change input value when changing approve incidence
				if ( prev.incidence?.diesel_liters !== undefined ) newData.incidence.diesel_liters = prev.incidence.diesel_liters; // Prevent change input value when changing approve incidence
				if ( prev.incidence?.approved !== undefined ) newData.incidence.approved = prev.incidence.approved; // Prevent change radio checked when changing approve incidence
				if ( prev.observations !== undefined ) newData.observations = prev.observations; // Prevent change observations when updating content
				return newData;
			});
			// --- INICIO: Simulación de datos dinámicos solo en desarrollo ---
			// setData((prev) => {
			// 	if (prev && prev.incidence && typeof newData.incidence === 'object' && newData.incidence) {
			// 		if (prev.incidence.sp95_liters !== undefined) newData.incidence.sp95_liters = prev.incidence.sp95_liters;
			// 		if (prev.incidence.diesel_liters !== undefined) newData.incidence.diesel_liters = prev.incidence.diesel_liters;
			// 		if (prev.incidence.approved !== undefined) newData.incidence.approved = prev.incidence.approved;
			// 	}
			// 	if (prev && prev.observations !== undefined) newData.observations = prev.observations;

			// 	if (process.env.NODE_ENV === 'development') {
			// 		newData.incidence_at = '2026-02-13T10:00:00Z';
			// 		newData.incidence = {
			// 			type: 'excess',
			// 			diesel_liters: 1234,
			// 			sp95_liters: 567,
			// 			approved: '1',
			// 			message: 'Mensaje de incidencia de prueba',
			// 		};
			// 		newData.status = 5;
			// 		newData.child = null;
			// 		newData.manualdata = {
			// 			albaran: 'A123456',
			// 			goa_liters: 1000,
			// 			sp95_liters: 500,
			// 			sent_at: '2026-02-13T11:00:00Z',
			// 		};
			// 		newData.diesel_liters = 2000;
			// 		newData.diesel_litrosaditivados = 100;
			// 		newData.sp95_liters = 1500;
			// 		newData.sp95_litrosaditivados = 50;
			// 		newData.seal = true;
			// 		newData.photos = [
			// 			{
			// 				id: 1,
			// 				ocr_result: 1,
			// 				ocr_sent: true,
			// 				ocr_sp95_qty_alert: false,
			// 				ocr_goa_qty_alert: true,
			// 				ocr: { value: 'OCR DATA' },
			// 				sent_at: '2026-02-13T12:00:00Z',
			// 				sent_log: 'Log de envío',
			// 			}
			// 		];
			// 		newData.numpedido_transporte = 'PED123';
			// 		newData.indicus_sent_at = '2026-02-13T13:00:00Z';
			// 		newData.indicus_sent_status = 'error';
			// 		newData.has_carrier_send_logs = true;
			// 		newData.observations = 'Observaciones de prueba';
			// 		newData.date = '2026-02-13';
			// 		newData.date_in = '2026-02-13T08:00:00Z';
			// 		newData.date_out = '2026-02-13T14:00:00Z';
			// 		newData.carrier = 'Transportes Demo';
			// 		newData.carrier_code = 'TD-001';
			// 		newData.hour_expected_init = '08:00';
			// 		newData.hour_expected_end = '09:00';
			// 		newData.id = 999;
			// 		newData.is_deletable = true;
			// 		newData.cancelled_at = null;
			// 		newData.parent_id = null;
			// 	}
				
			// 	return newData;
			// });
			// --- FIN: Simulación de datos dinámicos ---
		}).catch((error) => {
			if ( axios.isCancel(error) ) return;
		});	
	}, [props.id, forceReload]);

	const deleteTankerTruck = () => {
		let c = window.confirm('¿Seguro que quieres eliminar esta cisterna?');
		if ( !c ) return false;

		axios.delete('api/tankertrucks/delete/' + data.id, {
			cancelToken: axiosCancelToken.token
		}).then((response) => {
			props.close();
			props.forceReload();
	  	}).catch((error) => {
			if ( axios.isCancel(error) ) return;
			toast.error('Ha ocurrido un error al eliminar');
		});	
	}

	const cancelTankerTruck = () => {
		let c = window.confirm('¿Seguro que quieres cancelar esta cisterna?');
		if ( !c ) return false;

		axios.post('api/tankertrucks/cancel/' + data.id, {}, {
			cancelToken: axiosCancelToken.token
		}).then((response) => {
			props.close();
			props.forceReload();
	  	}).catch((error) => {
			if ( axios.isCancel(error) ) return;
			toast.error('Ha ocurrido un error al cancelar');
		});	
	}

	const viewPhoto = (id) => {
		axios.get('api/tankertrucks/view-photo/' + id, {
			cancelToken: axiosCancelToken.token,
			responseType: 'blob'
		}).then((response) => {
	    	const url = window.URL.createObjectURL(new Blob([response.data], {type: 'image/jpg'}));
	        window.open(url);
	  	}).catch((error) => {
			if ( axios.isCancel(error) ) return;
		});
	}

	const setIncidenceField = (fieldname, value) => {
		let incidence = {...data.incidence};
		incidence[fieldname] = value;
		setData((prev) => ({...prev, incidence: incidence}));
	}

	const saveIncidence = () => {
		data.manual = true; // Set manual on DB

		axios.post('api/tankertrucks/save-incidence/' + data.id, data.incidence, {
			cancelToken: axiosCancelToken.token
		}).then((response) => {
			toast.success('Datos guardados');
			props.forceReload();

			let tankerTruckUpdated = response.data.tankertruck;
			setData({...tankerTruckUpdated});

			// Show deviation modal
			if ( tankerTruckUpdated.incidence.type === 'excess' && tankerTruckUpdated.incidence.approved === '1' ) {
				setDeviationModal(true);
			}
	  	}).catch((error) => {
			if ( axios.isCancel(error) ) return;
			toast.error('Ha ocurrido un error al guardar');
		});	
	}

    const closeTankerTruckIssues = (issueId) => {

		axios.post('api/tankertrucks-issues/set-closed/' + issueId, {}, {
			cancelToken: axiosCancelToken.token
		}).then(() => {
			toast.success('Incidencias cerradas');
			getData();

	  	}).catch((error) => {
			if ( axios.isCancel(error) ) return;
			toast.error('Ha ocurrido un error al cerrar las incidencias');
		});
	}

	const getProbeData = async (showLoader = true) => {
		setProbeData(null);
		if ( showLoader ) setProbeLoading(true);
		await axios.get('api/probes/get/' + data.station_id, {
			params: {},
			cancelToken: axiosCancelToken.token
		}).then((response) => {
			setProbeData(response.data);
	  	}).catch((error) => {
			if ( axios.isCancel(error) ) return;
		});
		setProbeLoading(false);
	}

	const updateObservations = () => {
		axios.post('/api/tankertrucks/update-observations/' + props.id, 
			{ observations: data.observations}, 
			{ cancelToken: axiosCancelToken.token }
		).then((response) => {
			
		}).catch((error) => {
			if ( axios.isCancel(error) ) return;
			toast.error('Ha ocurrido un error');
		});	
	}

	const toggleOcrDetails = (e, id) => {
        e.stopPropagation();

        setOcrDetails(ocrDetails && ocrDetails === id ? null : id);
    }

	const resendToPegasus = (id) => {
		axios.post('/api/tankertrucks/resend-pegasus/' + id,
			{},
			{ cancelToken: axiosCancelToken.token }
		).then((response) => {
			setForceReload(Math.random());
		}).catch((error) => {
			if ( axios.isCancel(error) ) return;
			toast.error('Ha ocurrido un error');
		});
	}

	const toggleAccordion = (id) => {
		setOpenAccordions(prev => {
			const next = { ...prev };
			if (next[id]) delete next[id];
			else next[id] = true;
			return next;
		});
	};

	const deleteDeliveryNote = (id) => {
		axios.delete(`/api/tankertrucks-delivery-notes/delete/${id}`, {
			cancelToken: axiosCancelToken.token
		}).then(() => {
			toast.success('Albarán eliminado');
			getData();
		}).catch((error) => {
			if (axios.isCancel(error)) return;
			toast.error('Ha ocurrido un error al eliminar el albarán');
		});
	};

	const getDeliveryNotesFromPegasus = async () => {
		setLoadingDeliveryNotesGet(true);
		await axios.get(`/api/tankertrucks-delivery-notes/get-info-from-pegasus/${data.id}`, {
			cancelToken: axiosCancelToken.token
		}).then(() => {
			toast.success('Albaranes obtenidos');
			getData();
		}).catch((error) => {
			if (axios.isCancel(error)) return;
			toast.error('Ha ocurrido un error al obtener los albaranes');
		});
		setLoadingDeliveryNotesGet(false);
	};

	const sendDeliveryNotesToBC = async () => {
		setLoadingDeliveryNotesBC(true);
		await axios.post(`/api/tankertrucks/send-to-bc/${data.id}`, {}, {
			cancelToken: axiosCancelToken.token
		}).then(() => {
			toast.success('Albaranes enviados a BC');
			getData();
		}).catch((error) => {
			if (axios.isCancel(error)) return;
			toast.error('Ha ocurrido un error al enviar a BC');
		});
		setLoadingDeliveryNotesBC(false);
	};

	const resendDeliveryNote = (id) => {
		axios.post(`/api/tankertrucks-delivery-notes/resend/${id}`, {}, {
			cancelToken: axiosCancelToken.token
		}).then(() => {
			toast.success('Albarán marcado para reenvío');
			getData();
		}).catch((error) => {
			if (axios.isCancel(error)) return;
			toast.error('Ha ocurrido un error al reenviar el albarán');
		});
	};

	const downloadDeliveryNote = async (id) => {
		setLoadingDownload(prev => ({ ...prev, [id]: true }));
		await axios.get(`/api/tankertrucks-delivery-notes/download/${id}`, {
			cancelToken: axiosCancelToken.token,
			responseType: 'blob'
		}).then((response) => {
			const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
			window.open(url);
		}).catch((error) => {
			if (axios.isCancel(error)) return;
			if (error.response?.status === 404) {
				toast.warning('No se ha encontrado el PDF de este albarán');
			} else {
				toast.error('Ha ocurrido un error al descargar el albarán');
			}
		});
		setLoadingDownload(prev => ({ ...prev, [id]: false }));
	};

	useEffect(() => {
		getData();
	}, [getData]);


	useEffect(() => {
		let reloadInterval = setInterval(() => {
			getData();
		}, 5000);

		return function cleanup() {
			clearInterval(reloadInterval);
		}
	}, [getData]);

	return (
		<Tr className="details" isDeviation={data.parent_id ? true : false}>
			<td colSpan="100%">
				<div className="row ms-0 me-0">
					{ !data?.id && 
						<div className="col-md-12 text-center">
							{loader}
						</div>
					}

					{ data.id && 
						<React.Fragment>
							<div className="col-md-8">
								<div className="d-flex justify-content-between col-md-12 border-bottom mb-0 size14">
									<div>
										<b className="fw-bold">CISTERNA </b>
										<span className="ms-auto">
											{data.carrier} {data.carrier_code}
										</span>
									</div>
									<span className="ms-auto">
										{moment(data.date).format('DD-MM-YYYY')}
										&nbsp;entre las&nbsp;
										{moment('2022-09-16 ' + data.hour_expected_init).format('HH:mm')} - {moment('2022-09-16 ' + data.hour_expected_end).format('HH:mm')}
									</span>
								</div>
								<div className="row row-table-details">
									<div style={{ gridColumn: 1, padding: 0 }} />
									<div className="table-responsive mt-3 mb-1 p-3 bg-white rounded shadow-sm overflow-hidden col-table-details" style={{ gridColumn: 2 }}>
										<table className="table table-striped table-striped-custom-table">
											<tbody>
												{ (data.date_in && moment(data.date).format('YYYY-MM-DD') !== moment(data.date_in).format('YYYY-MM-DD')) &&
													<tr>
														<td>
															{ data.date_in ?
																<i className="bi bi bi-check-circle-fill text-success"></i>
																:
																<i className="bi bi-circle-fill" style={{color: 'var(--bs-gray-300)'}}></i>
															}
														</td>
														<td>Día de llegada</td>
														<td>{data.date_in ? moment(data.date_in).format('DD-MM-YYYY') : '-'}</td>
													</tr>
												}
												<tr>
													<td>
														{ data.date_in ?
															<i className="bi bi bi-check-circle-fill text-success"></i>
															:
															<i className="bi bi-circle-fill" style={{color: 'var(--bs-gray-300)'}}></i>
														}
													</td>
													<td>Hora de llegada</td>
													<td>{data.date_in ? moment(data.date_in).format('HH:mm') : '-'}</td>
												</tr>

												{ (data.date_out &&moment(data.date).format('YYYY-MM-DD') !== moment(data.date_out).format('YYYY-MM-DD')) &&
													<tr>
														<td>
															{ data.date_out ?
																<i className="bi bi bi-check-circle-fill text-success"></i>
																:
																<i className="bi bi-circle-fill" style={{color: 'var(--bs-gray-300)'}}></i>
															}
														</td>
														<td>Día de salida</td>
														<td>{data.date_out ? moment(data.date_out).format('DD-MM-YYYY') : '-'}</td>
													</tr>
												}
												<tr>
													<td>
														{ data.date_out ?
															<i className="bi bi bi-check-circle-fill text-success"></i>
															:
															<i className="bi bi-circle-fill" style={{color: 'var(--bs-gray-300)'}}></i>
														}
													</td>
													<td>Hora de salida</td>
													<td>{data.date_out ? moment(data.date_out).format('HH:mm') : '-'}</td>
												</tr>
												<tr>
													<td>
														{ (data.date_out && data.incidence?.diesel_liters === undefined) ?
															<i className="bi bi bi-check-circle-fill text-success"></i>
															:
															<i className="bi bi-circle-fill" style={{color: 'var(--bs-gray-300)'}}></i>
														}
													</td>
													<td>Cantidad GOA</td>
													<td>{data.diesel_liters_without_additives  ?? '-'}</td>
												</tr>
												{ data.diesel_litrosaditivados > 0 &&
													<tr>
														<td>
															{ data.date_out ?
																<i className="bi bi bi-check-circle-fill text-success"></i>
																:
																<i className="bi bi-circle-fill" style={{color: 'var(--bs-gray-300)'}}></i>
															}
														</td>
														<td>Cantidad GOA <span className="badge text-dark">ADITIVADO</span></td>
														<td>{data.diesel_litrosaditivados ?? '-'}</td>
													</tr>
												}
												<tr>
													<td>
														{ (data.date_out && data.incidence?.sp95_liters === undefined) ?
															<i className="bi bi bi-check-circle-fill text-success"></i>
															:
															<i className="bi bi-circle-fill" style={{color: 'var(--bs-gray-300)'}}></i>
														}
													</td>
													<td>Cantidad SP</td>
													<td>{data.sp95_liters_without_additives  ?? '-'}</td>
												</tr>
												{ data.sp95_litrosaditivados > 0 &&
													<tr>
														<td>
															{ data.date_out ?
																<i className="bi bi bi-check-circle-fill text-success"></i>
																:
																<i className="bi bi-circle-fill" style={{color: 'var(--bs-gray-300)'}}></i>
															}
														</td>
														<td>Cantidad SP <span className="badge text-dark">ADITIVADO</span></td>
														<td>{data.sp95_litrosaditivados ?? '-'}</td>
													</tr>
												}
												<tr>
													<td>
														{ data.seal ?
															<i className="bi bi bi-check-circle-fill text-success"></i>
															:
															<i className="bi bi-circle-fill" style={{color: 'var(--bs-gray-300)'}}></i>
														}
													</td>
													<td>Precinto</td>
													<td>{data.seal ? 'SI' : 'NO'}</td>
												</tr>
												<tr>
													<td>
														{ data.photos?.length > 0 ?
															<i className="bi bi bi-check-circle-fill text-success"></i>
															:
															<i className="bi bi-circle-fill" style={{color: 'var(--bs-gray-300)'}}></i>
														}
													</td>
													<td>Albarán</td>
													<td></td>
												</tr>
												<tr>
													<td>
														{ data.observations ?
															<i className="bi bi bi-check-circle-fill text-success"></i>
															:
															<i className="bi bi-circle-fill" style={{color: 'var(--bs-gray-300)'}}></i>
														}
													</td>
													<td style={{whiteSpace: 'nowrap'}}>
														Observaciones
													</td>
													<td>
														{ hasCapability('tankertrucks', 'edit') &&
															!editingObservations ?
																<button className="btn btn-sm btn-plenoil-outline-black d-flex flex-row flex-nowrap gap-2 align-items-center px-2 py-0" style={{ width: 26, height: 26, minWidth: 0, borderRadius: '1.5rem', paddingTop: '0 !important' }} onClick={() => setEditingObservations(true)}>
																	<i className="bi bi-pencil" style={{ lineHeight: '100%' }}></i>
																</button>
															:
																<button 
																	className="btn btn-sm btn-plenoil-outline-black d-flex flex-row flex-nowrap gap-2 align-items-center px-2 py-0" style={{ width: 26, height: 26, minWidth: 0, borderRadius: '1.5rem', paddingTop: '0 !important' }}
																	onClick={() => {
																		setEditingObservations(false);
																		updateObservations();
																	}}
																>
																	<i className="bi bi-check" style={{ lineHeight: '100%' }}></i>
																</button>
														}
													</td>
												</tr>
												{ (data.observations || editingObservations) &&
													<tr>
														<td colSpan="100%" className="ps-4 text-start">
															{ editingObservations ?
																<textarea className="form-control form-control-sm" value={data.observations ?? ''} maxLength="2000" onChange={(e) => setData((prev) => ({...prev, observations: e.target.value}))} />
																:
																data.observations
															}
														</td>
													</tr>
												}
											</tbody>
										</table>
									</div>
									<div className="table-responsive mt-3 col-table-details mb-1 p-3 bg-white rounded shadow-sm" style={{ gridColumn: 3, overflow: 'visible' }}>
										{data.manualdata &&
											<>
												<b className="d-block mt-1">
													LECTURA EXPENDEDOR
													{data.manualdata?.sent_at &&
														<>
															&nbsp;<i className="bi bi bi-check-circle-fill text-success"></i>
														</>
													}
												</b> 
                        
												<table className="table table-striped table-striped-custom-table mb-2">
													<tbody>
														{data.manualdata?.albaran &&
															<tr>
																<td className="text-start ps-2">
																	Nº Albaran
																</td>
																<td>
																	{data.manualdata?.albaran}
																</td>
															</tr>
														}
														{data.manualdata?.goa_liters !== 0 &&
															<tr>
																<td className="text-start ps-2">
																	Cantidad GOA
																</td>
																<td>
																	{data.manualdata?.goa_liters}
																</td>
															</tr>
														}
														{data.manualdata?.sp95_liters !== 0 &&
															<tr>
																<td className="text-start ps-2">
																	Cantidad SP95
																</td>
																<td>
																	{data.manualdata?.sp95_liters}
																</td>
															</tr>
														}
													</tbody>
												</table>
											</>
										}
                    
                    
										{ data.photos.length > 0 &&
											<>
												<b className="d-block mt-1">FOTOS</b>
												<div className="d-flex flex-column mb-2">
													{ data.photos.map((pEl, pIdx) => {
														return (
															<div key={pIdx} className="d-flex w-100 align-items-center justify-content-between mt-2">
																<button key={pIdx} className="m-0 py-0 d-inline-flex photo-btn" style={{ border: 'none', background: 'none'}} onClick={() => viewPhoto(pEl.id)}>
																	<i className="bi bi-image"></i>&nbsp;
																	Albarán foto {pIdx+1}
																</button>
																{pEl.ocr_result === 1 &&
																	<>
																		<button className="btn p-0 m-0 ms-auto" onClick={(e) => toggleOcrDetails(e, pEl.id)}>
																			<i
																				className="bi bi-qr-code ms-auto"
																				style={{
																					color: pEl.ocr_sp95_qty_alert || pEl.ocr_goa_qty_alert
																						? 'var(--plenoil-orange)'
																						: pEl.ocr_sent
																							? 'var(--plenoil-blue)'
																							: 'var(--plenoil-red)'
																				}}
																			></i>
																		</button>
																		<div 
																			className="position-relative"
																			onMouseLeave={(e) => toggleOcrDetails(e, null)}
																		>
																			{ ocrDetails === pEl.id &&
																				<OcrPopup
																					id={pEl.id}
																					data={pEl.ocr}
																					goaQtyAlert={pEl.ocr_goa_qty_alert}
																					sp95QtyAlert={pEl.ocr_sp95_qty_alert}
																					sentAt={pEl.sent_at}
																					sentLog={pEl.sent_log}
																					forceReload={() => {
																						setForceReload(Math.random());
																					}}
																				/>
																			}
																		</div>
																	</>
																}
															</div>
														)
													}) }
												</div>
											</>
										}
                                        { data.issues?.length > 0 &&
											<>
												<b className="d-block mt-1">INCIDENCIAS (ALBARÁN)</b>
												{ data.issues.map(issue => (
													<div key={issue.id} className="d-flex flex-row flex-nowrap gap-2 align-items-center justify-content-between mt-1">
														<span style={{ fontSize: 12 }}>
															{ issue.issueTypeId === 1 && 'Dif. cantidad combustible' }
															{ (issue.goaQuantityAlert && issue.sp95QuantityAlert) && ' (GOA y SP95)' }
															{ (issue.goaQuantityAlert && !issue.sp95QuantityAlert) && ' (GOA)' }
															{ (!issue.goaQuantityAlert && issue.sp95QuantityAlert) && ' (SP95)' }
														</span>
														<button className="btn btn-sm btn-plenoil btn-plenoil-outline-blue d-flex flex-row flex-nowrap gap-2 align-items-center px-3 py-0" style={{ width: 'max-content' }} onClick={() => setConfirmModal({ title: 'Cerrar incidencia', message: '¿Estás seguro de que quieres cerrar la incidencia?', onConfirm: () => closeTankerTruckIssues(issue.id) })}>
															<i className="bi bi-x-circle"></i> CERRAR INCIDENCIA
														</button>
													</div>
												)) }
											</>
                                        }

										<b className="d-block mt-1">ENVÍO A PEGASUS</b>
										<TableDetails>
											<tbody>
												<tr>
													<td className="text-start">
														<i className="bi bi-code-slash"></i>&nbsp;
														{(data.numpedido_transporte?.length > 0 && !data.indicus_sent_at) && 'Datos pendientes de enviar a Pegasus'}
														{data.indicus_sent_at && 'Datos enviados a Pegasus el ' + moment(data.indicus_sent_at).format('DD-MM-YYYY HH:mm:ss')}
													</td>
												</tr>
												{(data.indicus_sent_at && data.indicus_sent_status === 'error') && 
													<tr>
														<td className="text-start text-danger d-flex align-items-center flex-nowrap justify-content-between">
															<div>
																<i className="bi bi-code-slash"></i>&nbsp;
																Envío a Pegasus con errores, revisar historial 
															</div>
															<button className="btn btn-sm btn-plenoil btn-plenoil-outline-red d-flex flex-row flex-nowrap gap-2 align-items-center px-2 py-0 ms-2" style={{ width: 'max-content', minHeight: 28 }} onClick={() => resendToPegasus(data.id)}>
																<i className="bi bi-arrow-repeat"></i> Reenviar
															</button>
														</td>
													</tr>
												}
												{data.has_carrier_send_logs &&
													<tr>
														<td>
															<button className="btn btn-sm btn-plenoil btn-plenoil-outline-orange d-flex flex-row flex-nowrap gap-2 align-items-center px-2 py-0 m-auto" style={{ width: 'max-content', minHeight: 28 }} onClick={() => setCarrierSendLogsModal(data.id)}>
																<i className="bi bi-clock-history"></i> Historial de envíos Pegasus
															</button>
														</td>
													</tr>
												}
											</tbody>
										</TableDetails>
									</div>
								</div>
								<div className="row row-table-issues">
									<div style={{ gridColumn: 1, padding: 0 }} />
									<div className="table-responsive mt-3 mb-3 p-3 bg-white rounded solid shadow-sm overflow-hidden col-table-details">
										<div className="d-flex align-items-center justify-content-between mb-2 flex-wrap gap-2">
											<b>ALBARANES</b>
											<div className="d-flex gap-2 flex-wrap">
												{data.deliveryNotesManualGetAllowed &&
													<button
														className="btn btn-sm btn-plenoil btn-plenoil-outline-blue d-flex flex-row flex-nowrap gap-1 align-items-center px-2 py-0"
														style={{ width: 'max-content', minHeight: 28, fontSize: 11 }}
														onClick={getDeliveryNotesFromPegasus}
														disabled={loadingDeliveryNotesGet}
													>
														{loadingDeliveryNotesGet
															? <><span className="spinner-border spinner-border-sm" style={{ width: 10, height: 10, borderWidth: 2 }}></span> Buscando...</>
															: <><i className="bi bi-cloud-download"></i> Obtener albaranes</>
														}
													</button>
												}
												{data.isManualSendToBusinessCentralAllowed &&
													<button
														className="btn btn-sm btn-plenoil btn-plenoil-outline-blue d-flex flex-row flex-nowrap gap-1 align-items-center px-2 py-0"
														style={{ width: 'max-content', minHeight: 28, fontSize: 11 }}
														onClick={sendDeliveryNotesToBC}
														disabled={loadingDeliveryNotesBC}
													>
														{loadingDeliveryNotesBC
															? <><span className="spinner-border spinner-border-sm" style={{ width: 10, height: 10, borderWidth: 2 }}></span> Enviando...</>
															: <><i className="bi bi-send"></i> Enviar a BC</>
														}
													</button>
												}
												{data.deliveryNotesManualInsertAllowed &&
													<button
														className="btn btn-sm btn-plenoil btn-plenoil-outline-blue d-flex flex-row flex-nowrap gap-1 align-items-center px-2 py-0"
														style={{ width: 'max-content', minHeight: 28, fontSize: 11 }}
														onClick={() => setAddDeliveryNoteModal(true)}
													>
														<i className="bi bi-plus-circle"></i> Añadir albarán
													</button>
												}
											</div>
										</div>

										{(!data.deliveryNotes || data.deliveryNotes.length === 0) &&
											<div className="text-muted" style={{ fontSize: 12 }}>Sin albaranes</div>
										}

										{data.deliveryNotes?.map(dn => (
											<div key={dn.id} className="border rounded mb-2 overflow-hidden">
												<div
													className="d-flex align-items-center justify-content-between px-3 py-2"
													style={{ cursor: 'pointer', background: openAccordions[dn.id] ? 'var(--bs-gray-100)' : 'white', fontSize: 12 }}
													onClick={() => toggleAccordion(dn.id)}
												>
													<div className="d-flex align-items-center gap-2 flex-wrap">
														<i className={`bi bi-chevron-${openAccordions[dn.id] ? 'down' : 'right'}`}></i>
														<b>{dn.documentNumber}</b>
														<span className="text-muted">{moment(dn.distpatchDate).format('DD/MM/YYYY HH:mm')}</span>
														{dn.sendDate
															? <span className="badge bg-success" style={{ fontSize: 10 }}>BC {moment(dn.sendDate).format('DD/MM/YYYY HH:mm')}</span>
															: <span className="badge bg-secondary" style={{ fontSize: 10 }}>No enviado BC</span>
														}
													</div>
													<div className="d-flex align-items-center gap-2" onClick={e => e.stopPropagation()}>
														{dn.businessCentralSendLogs?.length > 0 &&
															<button
																className="btn btn-sm btn-plenoil btn-plenoil-outline-orange d-flex flex-row flex-nowrap gap-1 align-items-center px-2 py-0"
																style={{ fontSize: 11, minHeight: 24 }}
																onClick={() => setBcLogsModal({ logs: dn.businessCentralSendLogs, documentNumber: dn.documentNumber })}
															>
																<i className="bi bi-clock-history"></i> Logs BC
															</button>
														}
														{dn.deliveryNotePegasusId != null &&
															<button
																className="btn btn-sm btn-plenoil btn-plenoil-outline-blue d-flex flex-row flex-nowrap gap-1 align-items-center justify-content-center px-2 py-0"
																style={{ fontSize: 11, minHeight: 24 }}
																onClick={() => downloadDeliveryNote(dn.id)}
																disabled={!!loadingDownload[dn.id]}
															>
																{loadingDownload[dn.id]
																	? <><span className="spinner-border spinner-border-sm" style={{ width: 10, height: 10, borderWidth: 2 }}></span> Descargando...</>
																	: <><i className="bi bi-file-earmark-pdf"></i> PDF</>
																}
															</button>
														}
														{dn.sendDate &&
															<button
																className="btn btn-sm btn-plenoil btn-plenoil-outline-blue d-flex flex-row flex-nowrap gap-1 align-items-center px-2 py-0"
																style={{ fontSize: 11, minHeight: 24 }}
																onClick={() => setConfirmModal({ title: 'Reenviar albarán', message: `¿Seguro que quieres reenviar el albarán ${dn.documentNumber}?`, onConfirm: () => resendDeliveryNote(dn.id) })}
															>
																<i className="bi bi-arrow-repeat"></i> Reenviar
															</button>
															}
															{!dn.sendDate &&
															<button
																style={{ background: 'none', border: 'none', color: 'var(--bs-red)', fontSize: 14, lineHeight: 1, padding: 0, cursor: 'pointer' }}
																onClick={() => setConfirmModal({ title: 'Borrar albarán', message: `¿Seguro que quieres borrar el albarán ${dn.documentNumber}?`, onConfirm: () => deleteDeliveryNote(dn.id) })}
															>
																<i className="bi bi-trash"></i>
															</button>
															}
													</div>
												</div>
												{openAccordions[dn.id] &&
													<div className="px-3 pb-2 pt-1" style={{ borderTop: '1px solid var(--bs-gray-200)' }}>
														<table className="table table-sm table-bordered mb-0" style={{ fontSize: 11 }}>
															<thead>
																<tr>
																	<th>Tipo combustible</th>
																	<th>Cantidad (L)</th>
																	{dn.lines?.some(l => l.temperature != null) && <th>Temperatura</th>}
																	{dn.lines?.some(l => l.density != null) && <th>Densidad</th>}
																</tr>
															</thead>
															<tbody>
																{dn.lines?.map(line => (
																	<tr key={line.id}>
																		<td>
																			{line.fuelType === 1 && 'GOA'}
																			{line.fuelType === 5 && 'SP95'}
																		</td>
																		<td>{line.quantity}</td>
																		{dn.lines?.some(l => l.temperature != null) && <td>{line.temperature ?? ''}</td>}
																		{dn.lines?.some(l => l.density != null) && <td>{line.density ?? ''}</td>}
																	</tr>
																))}
															</tbody>
														</table>
													</div>
												}
											</div>
										))}
									</div>
								</div>
							</div>
							<IncidencesWrapper className="col-md-4">
								<div className="detail-col-right flex-column w-100" style={{ minWidth: 0 }}>
									{data.incidence_at && (
										<section className="mb-3 p-3 bg-white rounded shadow-sm overflow-hidden">
											<div className="d-flex align-items-center border-bottom pb-2 mb-2">
												<i className="bi bi-exclamation-triangle text-danger me-2"></i>
												<b>DESCARGA CON INCIDENCIAS</b>
											</div>
											<TableIncidenceType className="mb-2">
												<tbody>
													<tr>
														<td><i className={'bi bi-circle' + (data.incidence.type === 'address' ? '-fill text-danger' : '')}></i></td>
														<td>OTRA DIRECCIÓN</td>
													</tr>
													<tr>
														<td><i className={'bi bi-circle' + (data.incidence.type === 'excess' ? '-fill text-danger' : '')}></i></td>
														<td>EXCESO COMBUSTIBLE</td>
													</tr>
													<tr>
														<td><i className={'bi bi-circle' + (data.incidence.type === 'quantities' ? '-fill text-danger' : '')}></i></td>
														<td>OTRAS CANTIDADES</td>
													</tr>
													<tr>
														<td><i className={'bi bi-circle' + (data.incidence.type === 'others' ? '-fill text-danger' : '')}></i></td>
														<td>OTROS</td>
													</tr>
												</tbody>
											</TableIncidenceType>
											<div className="border-bottom text-danger fw-bold mb-2 pt-2">
												{data.incidence.type === 'address' && <>OTRA DIRECCIÓN</>}
												{data.incidence.type === 'quantities' && <>OTRAS CANTIDADES</>}
												{data.incidence.type === 'excess' && <>EXCESO COMBUSTIBLE</>}
												{data.incidence.type === 'others' && <>OTROS</>}
											</div>
											<div className="mb-2">
												{(data.incidence?.type === 'quantities' || data.incidence?.type === 'excess') && (
													<IncidenceQuantities>
														<div className="incidence-label">CANTIDAD GOA</div>
														<div className="incidence-input">
															<input type="number" className="form-control form-control-sm no-arrows" value={data.incidence.diesel_liters} onChange={(e) => setIncidenceField('diesel_liters', e.target.value)} style={{ maxWidth: 120 }} />
														</div>
														<div className="incidence-label">CANTIDAD SP</div>
														<div className="incidence-input">
															<input type="number" className="form-control form-control-sm no-arrows" value={data.incidence.sp95_liters} onChange={(e) => setIncidenceField('sp95_liters', e.target.value)} style={{ maxWidth: 120 }} />
														</div>
														<div style={{gridColumn: '1 / span 2'}}>
															<div className="d-flex justify-content-start gap-3 mt-2 flex-wrap">
																<label className="d-inline-flex align-items-center">
																	<input type="radio" name={data.id + '-incidence-quantities-radio'} value={1} checked={parseInt(data.incidence.approved) === 1} onChange={(e) => setIncidenceField('approved', e.target.value)} className="me-1 incidence-radio-approval" />
																	APROBAR
																</label>
																<label className="d-inline-flex align-items-center">
																	<input type="radio" name={data.id + '-incidence-quantities-radio'} value={0} checked={parseInt(data.incidence.approved) === 0} onChange={(e) => setIncidenceField('approved', e.target.value)} className="me-1 incidence-radio-approval" />
																	DENEGAR
																</label>
																<button className="btn btn-sm btn-plenoil btn-plenoil-outline-blue d-flex flex-row flex-nowrap gap-2 align-items-center px-3 py-0 mt-1" style={{ width: 'max-content' }} onClick={saveIncidence}>
																	<i className="bi bi-send"></i> ENVIAR
																</button>
															</div>
														</div>
													</IncidenceQuantities>
												)}
												{data.incidence?.type === 'others' && (
													<div className="bg-white py-1 px-2 rounded small mb-2">{data.incidence.message}</div>
												)}
												{data.incidence?.type === 'others' && (
													<div className="d-flex justify-content-start gap-3 mt-2 flex-wrap">
														<label className="d-inline-flex align-items-center">
															<input type="radio" name={data.id + '-incidence-quantities-radio'} value={1} checked={parseInt(data.incidence.approved) === 1} onChange={(e) => setIncidenceField('approved', e.target.value)} className="me-1" />
															APROBAR
														</label>
														<label className="d-inline-flex align-items-center">
															<input type="radio" name={data.id + '-incidence-quantities-radio'} value={0} checked={parseInt(data.incidence.approved) === 0} onChange={(e) => setIncidenceField('approved', e.target.value)} className="me-1" />
															DENEGAR
														</label>
														<button className="btn btn-sm btn-plenoil btn-plenoil-outline-blue d-flex flex-row flex-nowrap gap-2 align-items-center px-3 py-0 mt-1" style={{ width: 'max-content' }} onClick={saveIncidence}>
															<i className="bi bi-send"></i> ENVIAR
														</button>
													</div>
												)}
												{data.incidence?.type === 'address' && (
													<div className="d-flex justify-content-center gap-3 mt-2 flex-wrap">
														<label className="d-inline-flex align-items-center">
															<input type="radio" name={data.id + '-incidence-quantities-radio'} value={1} checked={parseInt(data.incidence.approved) === 1} onChange={(e) => setIncidenceField('approved', e.target.value)} className="me-1" />
															APROBAR
														</label>
														<label className="d-inline-flex align-items-center">
															<input type="radio" name={data.id + '-incidence-quantities-radio'} value={0} checked={parseInt(data.incidence.approved) === 0} onChange={(e) => setIncidenceField('approved', e.target.value)} className="me-1" />
															DENEGAR
														</label>
														<button className="btn btn-sm btn-plenoil btn-plenoil-outline-orange d-flex flex-row flex-nowrap gap-2 align-items-center px-3 py-0 mt-1" style={{ width: 'max-content' }} onClick={saveIncidence}>
															<i className="bi bi-send"></i> ENVIAR
														</button>
													</div>
												)}
											</div>
										</section>
									)}
									{data.status === 5 && (
										<section className="mb-3 p-3 bg-white rounded shadow-sm overflow-hidden">
											<div className="mt-1 mb-1">
												<i className="bi bi-check-circle-fill text-success"></i>
												&nbsp;
												<b>DESCARGA COMPLETADA</b>
											</div>
										</section>
									)}
									<div className="d-flex flex-row flex-wrap gap-2 align-items-start mt-3 w-100">
										{!data.child && (
											<button className="btn btn-sm btn-plenoil btn-plenoil-outline-orange d-flex flex-row flex-nowrap gap-2 align-items-center" style={{ width: 'max-content' }} onClick={() => setDeviationModal(true)}>
												<i className="bi bi-shuffle"></i> Desviar
											</button>
										)}
										<ButtonClose onClick={props.close} className="d-flex flex-row flex-nowrap align-items-center gap-2 btn btn-plenoil btn-plenoil-outline-blue" style={{ width: 'max-content' }}>
											<i className="bi bi-x-circle"></i>
											<div>Cerrar</div>
										</ButtonClose>
										<button className="btn btn-sm btn-plenoil btn-plenoil-orange mb-2" style={{ width: 'max-content' }} onClick={() => getProbeData(true)} disabled={probeLoading}>
											Pedir sonda
											{probeLoading && loader}
										</button>
										{probeData && (
											<div className="probes_wrapper flex-grow-1">
												<React.Fragment>
													<div className="py-2">
														<Tank
															className="w-100 mb-2"
															type="diesel"
															percent={probeData.diesel_percent}
															available={probeData.diesel_available}
															width={100}
														/>
														<Tank
															className="w-100"
															type="splomo"
															percent={probeData.splomo_percent}
															available={probeData.splomo_available}
															width={100}
														/>
													</div>
													{probeData.error && (
														<div className="invalid-feedback d-block mb-3"><b>Error al pedir la sonda:</b> {probeData.error}</div>
													)}
												</React.Fragment>
											</div>
										)}
									</div>
									<ButtonsBottom className="row flex-row flex-nowrap gap-3 mt-4 w-100">
										{!data.cancelled_at && (
											<button
												className="d-flex flex-row flex-nowrap gap-2 align-items-center"
												style={{ width: 'max-content', padding: '0px' }}
												onClick={cancelTankerTruck}
											>
												<i className="bi bi-x-circle"></i> Cancelar
											</button>
										)}
										{data.is_deletable && (
											<button
												className="d-flex flex-row flex-nowrap gap-2 align-items-center"
												style={{ width: 'max-content', padding: '0px' }}
												onClick={deleteTankerTruck}
											>
												<i className="bi bi-trash"></i> Eliminar
											</button>
										)}
									</ButtonsBottom>
								</div>
							</IncidencesWrapper>
						</React.Fragment>
					}
				</div>

				{ deviationModal && 
					<DeviationModal 
						parent={data}
						closeCallback={() => {
							setDeviationModal(false);
							props.forceReload();
							props.close();
						}}
					/>
				}

				{ carrierSendLogsModal &&
					<CarrierSendLogsModal
						id={carrierSendLogsModal}
						closeCallback={() => {
							setCarrierSendLogsModal(false);
						}}
					/>
				}

				{ confirmModal &&
					<ConfirmModal
						title={confirmModal.title}
						message={confirmModal.message}
						confirmCallback={confirmModal.onConfirm}
						closeCallback={() => setConfirmModal(null)}
					/>
				}

				{ bcLogsModal &&
					<DeliveryNotesBCLogsModal
						logs={bcLogsModal.logs}
						documentNumber={bcLogsModal.documentNumber}
						closeCallback={() => setBcLogsModal(null)}
					/>
				}

				{ addDeliveryNoteModal &&
					<DeliveryNotesAddModal
						pcar={data.order}
						closeCallback={(saved) => {
							setAddDeliveryNoteModal(false);
							if (saved) getData();
						}}
					/>
				}
			</td>
		</Tr>
	);
}


